import React from "react";
import { Tabs } from "@mantine/core";

import { PinnedReportRecipeList } from "@components/ReportRecipe";
import { LoyaltyMembershipLookup, HogApiMembershipCreate } from "@components/LoyaltyMembership";

export default function Dashboard() {
  return (
    <div>
      <Tabs defaultValue="lookup" keepMounted={false}>
        <Tabs.List mb="md">
          <Tabs.Tab value="lookup">Loyalty Membership Lookup</Tabs.Tab>
          <Tabs.Tab value="hog-api">HOG API Lookup</Tabs.Tab>
          <Tabs.Tab value="create">HOG API Create</Tabs.Tab>
        </Tabs.List>
        <Tabs.Panel value="lookup">
          <LoyaltyMembershipLookup identOnly={true} />
        </Tabs.Panel>
        <Tabs.Panel value="hog-api">
          <LoyaltyMembershipLookup title="HOG API Lookup" />
        </Tabs.Panel>
        <Tabs.Panel value="create">
          <HogApiMembershipCreate />
        </Tabs.Panel>
      </Tabs>
      <PinnedReportRecipeList
        reqData={{
          pinned_to: 1,
        }}
      />
    </div>
  );
}
